import { AbstractDataState, useGetContractBasedApiData } from '@cp-shared-15/frontend-integration';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';
import { fetchVehicleImage } from './VehicleImageSlice';
import { VehicleImageDataSelector } from './VehicleImageDataSelector';
import { getVehicleImageServiceEndpoint, VehicleImageServiceResponse, VehicleImageView } from '@cp-shared-15/apis';

export function useVehicleImage(
    encryptedVin: string,
    view?: VehicleImageView,
): AbstractDataState<VehicleImageServiceResponse, DefaultBusinessMarketApiErrorCode> {
    const params = view ? { view } : {};
    return useGetContractBasedApiData(
        encryptedVin,
        fetchVehicleImage,
        VehicleImageDataSelector,
        getVehicleImageServiceEndpoint(encryptedVin),
        false,
        {
            params,
        },
    );
}
